import numeral from 'numeral';

export default function () {
    numeral.register("locale", "custom-cameroon", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        currency: {
            symbol: "CFA" // XAF
        }
    })
}